<!--
/*
 * @Author: your name
 * @Date: 2021-07-05 15:57:34
 * @LastEditTime: 2022-11-01 09:55:17
 * @LastEditors: 李绍烽 shaofeng.li@southgis.com
 * @Description: In User Settings Edit
 * @FilePath: \maine:\git\xadc\src\views\ProjectPublicity\ProjectPublicityInfo.vue
 * @Description: 
 */
 -->

 <template>
  <div class="satisfaction-rate-info">
    <div class="detail-box">
      <div class="content-name">{{ detailData.gcmc }}</div>
      <div class="content-box">
        <div class="progress-cell">
          <div class="progress-title title">项目代码</div>
          <div class="progress-value title">{{ detailData.gcbh }}</div>
        </div>
        <div class="progress-cell">
          <div class="progress-title">行政区</div>
          <div class="progress-value">{{ detailData.xzq }}</div>
        </div>
        <div class="progress-cell">
          <div class="progress-title">项目地点</div>
          <div class="progress-value">{{ detailData.gcxxdd }}</div>
        </div>
        <div class="progress-cell">
          <div class="progress-title">建设单位</div>
          <div class="progress-value">{{ detailData.jsdw }}</div>
        </div>
        <div class="progress-cell">
          <div class="progress-title">测量事项</div>
          <div class="progress-value">{{ detailData.wtsxs }}</div>
        </div>
        <div class="progress-cell">
          <div class="progress-title ">操作</div>
          <div class="progress-value btn-click" @click="toDetail">查看进度</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NoData from '@/components/NoData.vue'
import api from '@/utils/api/projectProgress.api.js'
import commonApi from '@/utils/api/common'
import moduleMixins from '@/mixins/moduleMixins'
import listMixins from '@/mixins/comListMixins'
export default {
  name: 'ProjectPublicityInfo',
  mixins: [listMixins, moduleMixins],
  components: {
    NoData
  },
  props: {},
  data() {
    return {
      detailData: {},
      rowsList: [], // 信息列表
      columns: [], // 列表子项的左侧标题数组
      activeNames: [],
      allEvaluat: '',
      showReturn: false,
      returnMessage: '',
      returnData: {},
    }
  },
  watch: {
    show: {
      handler(val) {
        if (val) {
          this.prevent_back()
        } else {
          this.unitLevel = ''
          this.searchValue = ''
          this.remove_back()
        }
      }
    }
  },
  computed: {
    navTitle() {
      // return this.$route.query.title
      return '项目详情'
    }
  },
  methods: {
    toFile(file) {
      if (file.FJLJ) {
        //文件
        console.log('file', file)

        const params = this.UrlParamHash(file.FJLJ)
        console.log('params', params)
        let url =
          'macroPath=' +
          params['macroPath'] +
          '&fileName=' +
          decodeURI(params['fileName'])

        if (window.__wxjs_environment === 'miniprogram') {
          // eslint-disable-next-line no-undef
          wx.miniProgram.navigateTo({
            url: '/pages/downloadFile/downloadFile?' + url,
          })
        } else {
          this.$toast.fail('请使用小程序预览')
        }
      }
    },
    UrlParamHash(url) {
      var params = [],
        h
      var hash = url.slice(url.indexOf('?') + 1).split('&')
      //  console.log(hash)
      for (var i = 0; i < hash.length; i++) {
        h = hash[i].split('=') //
        params[h[0]] = h[1]
        //   console.log(h)
      }
      return params
    },
    // 获取项目进度查询和办理详情列表
    // loadData(res) {
    //   console.log('--res', res)
    //   if(!res.MYDPJ) {
    //     return
    //   }
    //   this.allEvaluat = res.MYDPJ.allEvaluat // 总体评价
    //   let arr = res.MYDPJ['columns'].filter(
    //     (item) => !res.MYDPJ['hideColumns'].includes(item.key)
    //   )
    //   res.MYDPJ.rowsList.forEach((element, index) => {
    //     element.CLSX = this.$store.state.projectCode[element.CLSX]
    //     // console.log('MYDPJ----', element)
    //     element.haveConfirm = element.CLZT == '待确认' ? true : false
    //     if (element.haveConfirm) {
    //       // 展开
    //       this.activeNames.push(index)
    //     }
    //   })
    //   //去除测试事项，因为在收缩板标题显示
    //   let CLSXCurrentIdx = arr.findIndex((itm) => itm.key == 'CLSX')
    //   arr.splice(CLSXCurrentIdx, 1)

    //   let czCurrentIdx = arr.findIndex((itm) => itm.key == 'CZ') //找到数组columns中key=CZ的下标索引(从0开始)
    //   console.log('操作项的索引值：', czCurrentIdx)
    //   let currentColumns = arr.splice(czCurrentIdx, 1) // 输出移除数组columns中key=CZ的对象[操作对象]
    //   console.log('currentColumns::', currentColumns, arr)
    //   arr.push(currentColumns[0]) // 将"操作"项添加至尾部

    //   this.columns = arr
    //   this.rowsList = res.MYDPJ['rowsList']
    // },
    // 跳转公示详情
    toDetail(){
      this.$router.push({
        name:"ProjectPublicityStep",
        params:{
          detailData: this.detailData,
        }
      })
    },
  },
  filters:{
    getCLSXText(val,that){
      let projectCodeArr = that.projectCode
      for(let i = 0; i < projectCodeArr.length; i++){
        if(projectCodeArr[i].code == val){
          return projectCodeArr[i].showValue
        }
      }
    },
  },
  created() {
    // this.onRefresh()
  },
  mounted() {
    //判断是否有中间页
    this.title = this.$route.query.title
    console.log(this.$route.params)
    this.detailData = this.$route.params

    // this.loadData(this.detailData)
    // this.$bus.$on('satisfyListOnload', () => {
    //   this.satisfyListOnload()
    // })
  },
  activated(){
  },
}
</script>
<style lang="scss" scoped>
.satisfaction-rate-info {
  // background: #ffffff;
  height: 100vh;
  .detail-box {
    background: #f1f3f6;
    padding: 0px 16px;
    .content-name {
      font-size: 17px;
      font-weight: bold;
      color: #333333;
      padding-top: 20px;
      // margin-bottom: 20px;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      line-clamp: 2;
      -webkit-line-clamp: 2; // 控制多行的行数
      -webkit-box-orient: vertical;
      z-index: 1;
      background: #f1f3f6;
      width: 100%;
      height: 46px;
    }
    .content-box {
      background: #ffffff;
      box-shadow: 0px 2px 5px 0px rgba(124, 130, 140, 0.2);
      border-radius: 5px;
    }
    .progress-cell {
      display: flex;
      align-items: center;
      padding: 4px 14px;
      .progress-title {
        font-size: 14px;
        font-weight: 500;
        color: #999999;
        width: 28%;
        text-align: right;
        padding: 5px 0px;
        &.title {
          font-weight: bold;
          color: #333333;
        }
      }
     
      .progress-value {
        flex: 1;
        font-size: 14px;
        font-weight: 500;
        border-radius: 1px;
        color: #333333;
        margin-left: 24px;
        text-align: left;
        &.title {
          font-weight: bold;
          color: #333333;
        }
        .status {
          padding: 4px 10px;
          &.grey {
            color: #333;
            background-color: #ddd;
          }
          &.yellow {
            color: #d78534;
            background-color: #ffebcc;
          }
          &.red {
            color: #fa6366;
            background-color: #ffd5d5;
          }
          &.green {
            color: #34cc8c;
            background-color: #dcf4ea;
          }
          &.blue {
            color: #155ede;
            background-color: #d5e4ff;
          }
        }
        .progress-confirm {
          font-size: 14px;
          font-weight: 500;
          color: #ffffff;
          background: #1d84ff;
          border-radius: 14px;
          padding: 7px 12px;
        }
        .progress-return {
          font-size: 14px;
          font-weight: 500;
          color: #ffffff;
          background: #fa6366;
          border-radius: 14px;
          padding: 7px 12px;
          margin-left: 10px;
        }
        .btn-isEnabled {
          background: #cfcfcf;
        }
        .progress-file {
          display: block;
          color: #3d93ff;
        }
      }
      .btn-click {
        color: #1d84ff !important;
      }
    }
    .btn-group {
      width: 100%;
      padding: 20px 0;
      margin: 30px 0;
      text-align: center;
      display: flex;
      justify-content: space-between;
      .btn {
        width: 45%;
      }
    }
  }
}
</style>
